export default "__VITE_ASSET__Bo9nndb0__"